import { SignIn } from '@clerk/clerk-react';

export function SignInPage() {
  return (
    <div className="flex h-full min-h-screen items-center justify-center bg-background p-4">
      <SignIn
        path="/sign-in"
        routing="path"
        signUpUrl="/sign-in"
        // Operators are pre-provisioned via the /admin/v1/staff invite
        // flow (P6). Self-service sign-up would create regular tenants;
        // staff users are minted by another staff:platform member, not
        // by visiting a /sign-up URL. Pointing signUpUrl back at
        // /sign-in keeps Clerk's "no account?" link from leading
        // anywhere productive — the operator either has a working
        // account or needs to be invited.
        fallbackRedirectUrl="/"
      />
    </div>
  );
}
